import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#00aeef",
        secondary: "#e4f2fe",
        error: "#bb6766",
        success: "#66bb6a",
        warning: "#efc300",
        accent: "#f5f5f5",
        app: "#ffffff"
      },
      dark: {
        primary: "#00aeef",
        secondary: "#1e2c38",
        error: "#bb6766",
        success: "#66bb6a",
        warning: "#efc300",
        accent: "#2a2a2a",
        app: "#272727"
      }
    },
    dark: false
  }
});

export default vuetify;
